export default __webpack_public_path__ + "static/media/Overnight Parking - Grey.675f5005.svg";